import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const CommonActions = createActionGroup({
    source: 'Common',
    events: {
        'Load Master Data':                emptyProps(),
        'Load Master Data Success':        props<{ masterData: Record<string, any[]> }>(),
        'Load Master Data Failure':        props<{ error: string }>(),

        'Load Business Entities':          emptyProps(),
        'Load Business Entities Success':  props<{ businessEntities: Record<string, any[]> }>(),
        'Load Business Entities Failure':  props<{ error: string }>(),

        'Load All Users':                  emptyProps(),
        'Load All Users Success':          props<{ users: any[] }>(),
        'Load All Users Failure':          props<{ error: string }>(),

        'Load All Internal Users':         emptyProps(),
        'Load All Internal Users Success': props<{ users: any[] }>(),
        'Load All Internal Users Failure': props<{ error: string }>(),

        'Load All Roles':                  emptyProps(),
        'Load All Roles Success':          props<{ roles: any[] }>(),
        'Load All Roles Failure':          props<{ error: string }>(),

        'Load All AE':                     emptyProps(),
        'Load All AE Success':             props<{ ae: any[] }>(),
        'Load All AE Failure':             props<{ error: string }>(),

        'Load All Rec':                    emptyProps(),
        'Load All Rec Success':            props<{ rec: any[] }>(),
        'Load All Rec Failure':            props<{ error: string }>(),

        'Load All Team Lead':              emptyProps(),
        'Load All Team Lead Success':      props<{ leads: any[] }>(),
        'Load All Team Lead Failure':      props<{ error: string }>(),

        'Load All Clients':                emptyProps(),
        'Load All Clients Success':        props<{ clients: any[] }>(),
        'Load All Clients Failure':        props<{ error: string }>(),

        'Load QB Users':                   emptyProps(),
        'Load QB Users Success':           props<{ users: any[] }>(),
        'Load QB Users Failure':           props<{ error: string }>(),

        'Load All Currency':               emptyProps(),
        'Load All Currency Success':       props<{ currency: any[] }>(),
        'Load All Currency Failure':       props<{ error: string }>(),
    }
});
